import React from "react";
import ReactDOMClient from "react-dom/client";

import { Route, createBrowserRouter, createRoutesFromElements, RouterProvider } from "react-router-dom";

import "./custom.scss";
import "bootstrap/dist/js/bootstrap.js";


import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

import App from "./App";
import Quiz from "./components/Quiz";
import Exam from "./components/Exam";
import CategoriesPage from "./components/CategoriesPage";
import TopicsPage from "./components/TopicsPage";
import QuestionsPage from "./components/QuestionsPage";
import QuestionPage from "./components/QuestionPage";


import { categories, topics, questions } from "./Data";
import WithAnswers from "./components/WithAnswers";

const container = document.getElementById("root");

const root = ReactDOMClient.createRoot(container);

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route index element={<CategoriesPage />} loader={async () => { return { categories } }} />
      <Route element={<WithAnswers />}>
        <Route path="quiz/*" element={<Quiz />}>
          <Route path="options" element={<Quiz />} />
          <Route path="results" element={<Quiz />} />
        </Route>
      </Route>
      <Route element={<WithAnswers />}>
        <Route path="exam/*" element={<Exam />}>
          <Route path="options" element={<Exam />} />
          <Route path="results" element={<Exam />} />
        </Route>
      </Route>
      <Route path=":categoryParam/*">
        <Route index element={<TopicsPage />} loader={async ({ params }) => {
          const topicsData = topics(params.categoryParam);
          if (topicsData.length === 0) {
            throw new Response("Not Found", { status: 404 })
          }
          return { topics: topicsData };
        }} />
        <Route element={<WithAnswers />}>
          <Route path="quiz/*" element={<Quiz />}>
            <Route path="options" element={<Quiz />} />
            <Route path="results" element={<Quiz />} />
          </Route>
        </Route>
        <Route element={<WithAnswers />}>
          <Route path="exam/*" element={<Exam />}>
            <Route path="options" element={<Exam />} />
            <Route path="results" element={<Exam />} />
          </Route>
        </Route>
        <Route path=":topicParam/*">
          <Route index element={<QuestionsPage />} loader={async ({ params }) => {
            const questionsData = questions(params.categoryParam, params.topicParam);
            if (Object.entries(questionsData).length === 0) {
              throw new Response("Not Found", { status: 404 })
            }
            return { questions: questionsData };
          }} />
          <Route element={<WithAnswers />}>
            <Route path="quiz/*" element={<Quiz />}>
              <Route path="options" element={<Quiz />} />
              <Route path="results" element={<Quiz />} />
            </Route>
          </Route>
          <Route element={<WithAnswers />}>
            <Route path="exam/*" element={<Exam />}>
              <Route path="options" element={<Exam />} />
              <Route path="results" element={<Exam />} />
            </Route>
          </Route>
          <Route path=":questionID" element={<QuestionPage />} />
        </Route>
      </Route>

    </Route>
  )
);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
